import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { LoadingButtonDirective } from '../loading-button.directive';

@Component({
  selector: 'lib-auth-otp-form',
  imports: [
    FormsModule,
    MatButton,
    MatFormFieldModule,
    MatInput,
    MatLabel,
    LoadingButtonDirective,
  ],
  template: `
    <form #form="ngForm" (ngSubmit)="confirm.emit(form.value.otp)">
      <mat-form-field>
        <mat-label>MFA code</mat-label>
        <input
          matInput
          name="otp"
          [(ngModel)]="otp"
          type="text"
          inputmode="numeric"
          [minlength]="otpLength"
          [maxlength]="otpLength"
          [disabled]="disabled()"
          required
          #otpCtrl="ngModel"
        />
        @if (otpCtrl.hasError('required')) {
          <mat-error>One time password code is required</mat-error>
        }
      </mat-form-field>

      <div class="button-container">
        <button
          mat-flat-button
          [disabled]="form.invalid"
          [loading]="disabled()"
        >
          Continue
        </button>
        @if (!disableResend()) {
          <button
            mat-button
            type="button"
            (click)="resend.emit()"
            [loading]="resendLoading()"
          >
            Resend email
          </button>
        }
      </div>
    </form>
  `,
  styles: `
    mat-form-field {
      display: block;
      margin-top: 1rem;
    }

    .button-container {
      display: flex;
      justify-content: space-between;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OtpformComponent {
  disabled = input(false);
  resendLoading = input(false);
  disableResend = input(false);

  readonly resend = output<void>();
  readonly confirm = output<string>();

  otp = model<string>('');

  readonly otpLength = 6;
}
